import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterGameType'
})
export class FilterGameTypePipe implements PipeTransform {

  transform(value: any[], args?: any): any {
    return value.filter(item => item.game_type === args);
  }

}
